export const cldrJsonDataEN = [require("./cldr-data/en")];
